import React from "react";

import { useTracked } from "./state";
import { Redirect, Route, Switch } from "react-router-dom";
import { IonReactRouter } from "@ionic/react-router";
import { IonSplitPane, IonRouterOutlet } from "@ionic/react";

import Menu from "./components/Menu";
// import Login from './pages/Login';
import Lock from "./pages/Lock";
// import Landing from './pages/Landing';
import Auth from "./Auth";
// import PendingShare from "./components/PendingShare";
import Issuers from "./pages/Issuers";
import Aliases from "./pages/Aliases";
import AddAlias from "./pages/AddAlias";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Help from "./pages/Help";
import Settings from "./pages/Settings";
import Accounts from "./pages/Accounts";
import AddAccount from "./pages/AddAccount";
import Requests from "./pages/Requests";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import SignInRequests from "./pages/SignInRequests";
import Onboarding from "./pages/Onboarding";
import Personalize from "./pages/Personalize";
import Signin from "./pages/Signin";
import Register from "./pages/Register";
import ReportIssues from "./pages/ReportIssues";
import SuggestFeature from "./pages/SuggestFeature";
import SessionChecker from "./SessionChecker";

const PrivateRoute = ({ component: C, ...rest }: any) => {
  const [state] = useTracked();

  return (
    <Route
      {...rest}
      render={(props: any) => {
        const isAppLocked = localStorage.getItem("isAppLocked");

        if (
          isAppLocked &&
          state.hasSession &&
          [
            AuthMode.PasscodeOnly,
            AuthMode.BiometricOnly,
            AuthMode.BiometricAndPasscode,
          ].includes(state.authMode)
        ) {
          return <Lock {...props} />;
        }

        return state.token ? <C {...props} /> : <Redirect exact to="/" />;
      }}
    />
  );
};

const PublicRoute = ({ component: C, ...rest }: any) => {
  const [state] = useTracked();
  return (
    <Route
      {...rest}
      render={(props: any) => {
        const isAppLocked = localStorage.getItem("isAppLocked");

        // !state.token ? (
        //   <>
        //     {state.hasSession &&
        //     // && state.biometricsSupported
        //     // && localStorage.getItem("isAppLocked")
        //     state.authMode !== AuthMode.SecureStorage ? (
        //       <Lock {...props} />
        //     ) : (
        //       <C {...props} />
        //     )}
        //   </>
        // ) : (
        //   <Redirect exact to="/issuers" />
        // )

        if (
          isAppLocked &&
          state.hasSession &&
          [
            AuthMode.PasscodeOnly,
            AuthMode.BiometricOnly,
            AuthMode.BiometricAndPasscode,
          ].includes(state.authMode)
        ) {
          return <Lock {...props} />;
        }

        return state.token ? (
          <Redirect exact to="/issuers" />
        ) : (
          <C {...props} />
        );
      }}
    />
  );
};

const AppRoutes: React.FC = () => {
  return (
    // @ts-ignore
    <IonReactRouter>
      <IonSplitPane contentId="main" className="app-split-pane">
        <Menu />
        <IonRouterOutlet id="main">
          <Switch>
            <PublicRoute path="/" component={Signin} exact={true} />
            <PublicRoute path="/register" component={Register} exact={true} />
            <PublicRoute
              path="/onboarding"
              component={Onboarding}
              exact={true}
            />
            <PrivateRoute
              path="/personalize"
              component={Personalize}
              exact={true}
            />
            <PublicRoute
              path="/public/privacy-policy"
              component={PrivacyPolicy}
              exact={true}
            />
            <PublicRoute
              path="/public/terms-and-conditions"
              component={TermsOfUse}
              exact={true}
            />

            <PrivateRoute
              path="/privacy-policy"
              component={PrivacyPolicy}
              exact={true}
            />
            <PrivateRoute
              path="/terms-and-conditions"
              component={TermsOfUse}
              exact={true}
            />
            <PrivateRoute path="/help" component={Help} exact={true} />
            <PrivateRoute
              path="/report"
              component={ReportIssues}
              exact={true}
            />
            <PrivateRoute
              path="/suggest-feature"
              component={SuggestFeature}
              exact={true}
            />
            {/* <PublicRoute path="/" component={Landing} exact={true} /> */}

            <Route path="/auth/:token" component={Auth} exact={true} />

            <PrivateRoute path="/issuers" component={Issuers} exact={true} />
            <PrivateRoute path="/aliases" component={Aliases} exact={true} />
            <PrivateRoute
              path="/add-alias/:id?"
              component={AddAlias}
              exact={true}
            />
            <PrivateRoute path="/settings" component={Settings} exact={true} />
            <PrivateRoute path="/accounts" component={Accounts} exact={true} />
            <PrivateRoute
              path="/add-account/:id?"
              component={AddAccount}
              exact={true}
            />
            <PrivateRoute path="/requests" component={Requests} exact={true} />
            <PrivateRoute
              path="/requests-sign-in"
              component={SignInRequests}
              exact={true}
            />
          </Switch>
        </IonRouterOutlet>
      </IonSplitPane>
      {/* unused component */}
      {/* <PendingShare /> */}
      <SessionChecker />
    </IonReactRouter>
  );
};

export default AppRoutes;
